<div>
    <am-topbar></am-topbar>
    <div class="container py-4 mt-2">
        <div class="row">
            <div class="col-md-3 d-none d-md-block">
                <am-sidebar></am-sidebar>
            </div>
            <div class="col-sm-9">
                <div>
                    <div style="height: 100%; position: relative;">
                        <div [@slideFadeinUp]="routeAnimation(outlet, 'slideFadeinUp')" [@slideFadeinRight]="routeAnimation(outlet, 'slideFadeinRight')" [@zoomFadein]="routeAnimation(outlet, 'zoomFadein')" [@fadein]="routeAnimation(outlet, 'fadein')">
                            <router-outlet #outlet="outlet" (activate)="changeOfRoutes()"></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <am-footer></am-footer>
</div>